import { FormKitNode } from "@formkit/core";
import { getDefaultGridPreset, UserGridPreset } from "@q-food/q-food";
import type { FilterModel } from "ag-grid-community";
import { replaceVariables } from "~utils/Forms/Autocomplete.ts";

async function openGridLookup(node: FormKitNode, filters?: FilterModel) {
	const optionsSource = node.props.optionsSource as string;

	const rootNode = node.at("$root");
	const rootForm = rootNode?.type === "group" ? rootNode : undefined;
	const resource = replaceVariables(optionsSource, { ...node.props, node }, rootForm);

	const gridPreset = await getDefaultGridPreset(node.props.attrs?.["grid-key"]).catch((e) => console.log(e));

	node.emit(
		"autocompleteLookup",
		{
			gridKey: node.props.attrs?.["grid-key"],
			originalOptionsSource: node.props.optionsSource,
			originalOptionSource: node.props.optionSource,
			optionsSourceWithDependencies: resource,
			selectionMode: node.props?.multiple ? "multiRow" : "singleRow",
			filters: applyFilters(gridPreset, filters),
		},
		true,
	);
}

/**
 * Adds an event listener to the suffix icon of an autocomplete input.
 * The event listener will emit an event telling the autocomplete to open the grid lookup.
 */
const plugin = (node: FormKitNode) => {
	if (node.type === "input" && node.props.type === "autocomplete" && node.props.suffixIcon === "search") {
		node.props.onSuffixIconClick = () => {
			if (!node.props.disabled && !node.props.readonly) {
				openGridLookup(node);
			}
		};
	}
};

function applyFilters(gridPreset?: UserGridPreset, filters?: FilterModel): string {
	let filterObject = {};
	if (gridPreset != null) {
		filterObject = JSON.parse(gridPreset.filterState);
	}
	if (filters != null) {
		filterObject = { ...filterObject, ...filters };
	}

	return JSON.stringify(filterObject);
}

export { openGridLookup };
export default plugin;
